import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';

export const insightsQueryExpressionMonarchLanguage: monaco.languages.IMonarchLanguage =
{
  ignoreCase: true,

  brackets: [
    { open: '{', close: '}', token: 'delimiter.curly' },
    { open: '(', close: ')', token: 'delimiter.parenthesis' }
  ],

  keywords: [
    'AND',
    'OR',
    'NOT',
    'IS',
  ],

  operators: [
    '=',
    '==',
    '<>',
    '!=',
    '<',
    '<=',
    '>',
    '>=',
    '&&',
    '||',
    '!', '~', '?', ':',
    '+', '-', '*', '/', '%',
    '&', '|', '^',
  ],

  tokenizer: {
    root: [
      { include: '@comments' },

      { include: '@quotedIdentifiers' },

      { include: '@whitespace' },
      { include: '@numbers' },
      { include: '@strings' },

      [/[;,.]/, 'delimiter'],
      [/[{}()]/, '@brackets'],
      [
        /[\w]+/, {
          cases: {
            '@keywords': 'keyword',
            '@default': 'identifier'
          }
        }
      ],
      [
        /[=><!~?:&|+\-*\/\^%]+/, {
          cases: {
            '@operators': 'operator'
          }
        }
      ]
    ],

    /* Single and multiline comments, i.e.
     * // ...
     * /* ... */
    comments: [
      [/\/\/+.*/, 'comment'],
      [/\/\*/, 'comment.quote', '@comment']
    ],
    comment: [
      [/[^*/]+/, 'comment'],
      [/\/\*/, 'comment.quote', '@push'],
      [/\*\//, 'comment.quote', '@pop'],
      [/./, 'comment']
    ],

    whitespace: [
      [/\s+/, 'white']
    ],

    /* Hexdecimal, decimal and real numbers. */
    numbers: [
      [/0[xX][0-9a-fA-F]*/, 'number'],
      [/[$][+-]*\d*(\.\d*)?/, 'number'],
      [/((\d+(\.\d*)?)|(\.\d+))([eE][\-+]?\d+)?/, 'number']
    ],

    /* Catch square bracket identifiers, e.g. [Cost], [Vendors.Vendor Name]. */
    quotedIdentifiers: [
      [/\[/, { token: 'identifier.quoted', next: '@quotedIdentifier', bracket: '@open' }]
    ],
    quotedIdentifier: [
      [/[^\]]+/, 'identifier.quoted'],
      [/\]/, { token: 'identifier.quoted', next: '@pop', bracket: '@close' }]
    ],

    /* Catch single and double quoted strings, e.g. 'hello', "hello".
     * Quotes are escaped the same way as in SQL, that is with double character. */
    strings: [
      [/'/, 'string', '@singleQuoteString'],
      [/"/, 'string', '@doubleQuoteString'],
    ],
    singleQuoteString: [
      [/[^']+/, 'string'],
      [/''/, 'string'],
      [/'/, 'string', '@pop']
    ],
    doubleQuoteString: [
      [/[^"]+/, 'string'],
      [/""/, 'string'],
      [/"/, 'string', '@pop']
    ],
  }
}
